module.exports = __webpack_public_path__ + "img/SA.b2815513.png";